import {alpha, Button, styled} from '@mui/material';

export const ChipButton = styled(Button)(({theme, ...props}) => {
  return {
    borderRadius: 50,
    backgroundColor: theme.palette.action.selected,
    paddingLeft: props.startIcon ? theme.spacing(1) : theme.spacing(1.5),
    paddingRight: props.endIcon ? theme.spacing(1) : theme.spacing(1.5),
    '&:hover, &:active': {
      backgroundColor: alpha(
        theme.palette.action.selected,
        theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity,
      ),
    },
  };
});
